import React from 'react'
import { CTA,Brand , Navbar} from './components'
import { Footer , Blog ,Possibility , Features , WhatGPT3 , Header } from './container'
import './App.css'
export default function App() {
  return (
    <div className = "App">
      <div className="gradient__bg">
      <Navbar/>
      <Header/>
      </div>
      <Brand/>
      <WhatGPT3/>
      <Features/>
      <Possibility/>
      <CTA/>
      <Blog/>
      <Footer/>

    </div>
    
  )
}
